exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".data-price{width:100%;padding:0 8px}.data-price .provider-company{text-align:center}.price-box{display:grid;grid-template-columns:repeat(2,max-content);justify-content:space-between;align-items:center;font-size:1rem;width:100%;padding:0 8px}.price-box__night-count{display:grid;align-items:flex-start;text-align:left;height:100%}.price-box__price{text-align:right}.price-box .deal-interval{font-size:.95rem}.loader{text-align:center}body[dir=rtl] .price-box__night-count {\n  text-align: right;\n}body[dir=rtl] \n.price-box__price {\n  text-align: left;\n}\n", ""]);

// exports
